import Vue from 'vue'
import Router from 'vue-router'
import home from '@/view/index'
import mobile from '@/view/mobile'

Vue.use(Router)

export default new Router({
  mode:"history",
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path:'/mobile',
      name:'mobile',
      component: mobile,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js